import styled from "styled-components"
import { Link as GLink } from "gatsby"

import { media } from "src/uikit"

export const Headline = styled.h1`
  font-weight: 800;
  font-size: 40px;
  line-height: 48px;
  color: #fff;
  margin-top: 24px;
  margin-bottom: 24px;

  span {
    color: #5ce0dc;
  }

  @media ${media.tablet} {
    margin-top: 0;
  }

  @media ${media.mobile} {
    font-size: 20px;
    line-height: 28px;
  }
`

export const Headline2 = styled(Headline)`
  font-weight: bold;
  font-size: 28px;
  line-height: 36px;
  color: #fff;

  a {
    color: #5ce0dc !important;
  }

  @media ${media.mobile} {
    font-size: 20px;
    line-height: 28px;

    a {
      font-size: 20px !important;
      line-height: 28px !important;
    }
  }
`

export const Paragraph = styled.p`
  margin: 0;
  margin-bottom: 12px;
  font-weight: normal;
  font-size: 17px;
  line-height: 32px;
  letter-spacing: 0.5px;
  color: #ffffff;

  a {
    font-size: 17px !important;
    line-height: 32px !important;
    color: #fff !important;
    font-weight: 600;
  }

  @media ${media.mobile} {
    font-size: 15px;
    line-height: 28px;
    letter-spacing: 0.5px;
  }
`

export const Link = styled.a`
  font-size: 28px;
  line-height: 36px;
  text-align: center;
  letter-spacing: 0.4px;
  color: #5ce0dc;
  text-decoration: underline;

  @media ${media.mobile} {
    font-size: 15px;
    line-height: 28px;
    letter-spacing: 0.5px;
  }
`

export const InnerLink = styled(GLink)`
  font-size: 28px;
  line-height: 36px;
  text-align: center;
  letter-spacing: 0.4px;
  color: #5ce0dc;
  text-decoration: underline;

  @media ${media.mobile} {
    font-size: 15px;
    line-height: 28px;
    letter-spacing: 0.5px;
  }
`
